import { useState, useEffect, useMemo } from 'react';

import api from '../../../apis';
import moment from 'moment';
import { useLoading } from '../../../context/LoadingContext';

import ReactTable from '../../general/form-control/react-table';
// import DetailTable from '../../general/info-control/table-detail';
import statusText from '../../../constants/property';

import { HeaderDiv } from '../../tables/helper';
import { parseAPIResultToData } from '../../general/form-control/tree-select/helper';

import { numberWithCommas } from '../../general/convertor';

import { usePagination } from '../../tables/helper';

import TradeOrderLogsTbl from '../../tables/TradeOrderLogsTbl'

import { DatePicker, Tooltip } from 'antd';
import FilterInputBuilder from '../../filterInputBuilder';

import Property from '../../../constants/property'
import { siderWidth } from '../../../constants/layout'
import OpenButton from '../../layouts/OpenButton';
import CloseButton from '../../layouts/CloseButton';
import { motion } from "framer-motion";
import MotionLayout from '../../general/framer-motion/MotionLayout';

const total_buy_sell_table_format = () => {
    const total_buy_sell_table_format = [
        {
            id: 'total',
            label: 'No of Contracts',
            type: 'quantity',
            value: '-'
        },
        {
            id: 'quantity',
            label: 'Quantity',
            type: 'quantity',
            value: '-'
        },
        {
            id: 'amount',
            label: 'Value',
            type: 'value',
            value: '-'
        }
    ];

    return total_buy_sell_table_format;
};

const Index = () => {
   // const siderWidth = '200px';//sider width

    const { setNotiLoading } = useLoading();
    const { tablePagination, setTablePagination } = usePagination();
    const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
    const [tableLoading, setTableLoading] = useState(false);

    useEffect(() => {}, []);

    const [currentAccNo, setCurrentAccNo] = useState<any>([]);
    const [inputs, setInputs] = useState<any>({});

    const [tableData, setTableData] = useState([]);
    // const [tablePagination, setTablePagination] = useState<any>({
    //     currentPage: 1,
    //     totalRecords: 0
    // });

    // usePagination;

    const [totalBuyData, setTotalBuyData] = useState<any>(null);
    const [totalSellData, setTotalSellData] = useState<any>(null);

    useEffect(() => {
        preSubmitRequest(currentAccNo, inputs);
    }, [currentAccNo, inputs]);

    const preSubmitRequest = (currentAccNo:any,inputs:any) => {
        if (currentAccNo.length > 0) {
            requestGetTradeHistorytAPI(inputs,currentAccNo);
        } else if (currentAccNo.length == 0) {
            handleResetTables();
        }
    }


    const requestGetTradeHistorytAPI = async (_inputs:any = null,accNo: any = null, cPage = 1) => {
        setTableLoading(true);
        setNotiLoading(true);
        
        let apiInputs = _inputs || inputs;
        let currentAccountNo =  accNo || inputs['accounts[]'];
       // console.log('requestGetTradeHistorytAPI apiInputs', apiInputs);
        let result = await api.getTradeHistory(currentAccountNo, apiInputs, cPage);

       // console.log('getTradeHistory', result);
        // console.log('resultSummary', resultSummary.summary);
        if (result.trades) {
            let trades = result.trades;
            //  console.log(contracts);
            setTableData(trades);
            //  updateAccSummaryComponent(account);
        }

        if (result.total) {
            // handlePagination('currentPage', cPage);
            // handlePagination('totalRecords', result.total);
            setTablePagination({
                currentPage: cPage,
                totalRecords: result.total
            });
        }

     

        // hideNotiLoader();
        setNotiLoading(false);
        setTableLoading(false);
    };



    const handleSubmit = (e: any) => {
        e.preventDefault();
    };

    function truncate(source:any, size:any) {
        return source.length > size ? source.slice(0, size - 1) + '…' : source;
    }

    const tblColumns = useMemo(
        () => [
            {
                Header: <>Process Time</>,
                id: 'o_time_entry',
                accessor: 'o_time_entry',
                Cell: (v: any) => {
                    if (v.value){
                        const formattedDate1 = moment(v.value).format('YYYY-MM-DD');
                        const formattedTime = moment(v.value).format('HH:mm:ss');
                        return <div style={{width:"max-content"}}><div>{formattedDate1}</div><div>{formattedTime}</div></div>;
                    }
                        
                }
            },
            {
                Header: 'Client Code',
                accessor: 'a_acctno'
            },
            {
                Header: 'Side',
                accessor: 'action_name'
            },
            {
                Header: 'Stock Code',
                accessor: 't_code'
            },
            {
                Header: 'Symbol',
                accessor: 't_name',
                Cell: ({ row }:any) => {
                    let rowData = row?.original;
                    let e_name = rowData.e_name || '';

                    if (e_name) {
                        e_name = truncate(e_name, 5);
                    }

                    // console.log(row?.original)
                    return (
                        <div className="d-flex flex-column gap-2 align-items-center ">
                            <Tooltip placement="topLeft" title={rowData.e_name}>
                                <div className="custom-tag cursor-pointer">
                                    {e_name}
                                </div>
                            </Tooltip>
                            <div>{rowData.t_name}</div>
                        </div>
                    );
                }
            },
            
            {
                Header: <div className="text-right">Order Prc.</div>,
                accessor: 'price',
                Cell: (v: any) => {
                    if (v.value)
                        return (
                            <div className="text-right">
                                {numberWithCommas(v.value, 3)}
                            </div>
                        );
                }
            },
            {
                Header: <HeaderDiv content={'Order Qty.'} type={'value'} />,
                accessor: 'quantity',
                Cell: (v: any) => {
                    if (v.value)
                        return (
                            <div className="text-right">
                                {numberWithCommas(v.value)}
                            </div>
                        );
                }
            },
            {
                Header: <div className="text-right">Match Qty.</div>,
                accessor: 'matchedquantity',
                Cell: (v: any) => {
                    if (v.value||v.value ===0)
                        return (
                            <div className="text-right">
                                {numberWithCommas(v.value)}
                            </div>
                        );
                }
            },
            {
                Header: <>Order Time</>,
                id: 'o_time_create',
                accessor: 'o_time_create',
                Cell: (v: any) => {
                    if (v.value){
                        const formattedDate1 = moment(v.value).format('YYYY-MM-DD');
                        const formattedTime = moment(v.value).format('HH:mm:ss');
                        return <div style={{width:"max-content"}}><div>{formattedDate1}</div><div>{formattedTime}</div></div>;
                    }
                        
                }
            },
            {
                Header: 'Order Category',
                accessor: 'o_category',
                Cell: (v: any) => {
                    if (v.value)
                        return (
                            <>{Property.categoriesText[v.value]}</>
                        );
                }        
            },
            {
                Header: 'Order Type',
                accessor: 'type_name'
            },
            {
                Header: 'Currency',
                accessor: 'c_code'
            },
            
            {
                Header: <>Expiry Time</>,
                id: 'o_time_expired',
                accessor: 'o_time_expired',
                Cell: (v: any) => {
                    if (v.value){
                        const formattedDate1 = moment(v.value).format('YYYY-MM-DD');
                        const formattedTime = moment(v.value).format('HH:mm:ss');
                        return <div style={{width:"max-content"}}><div>{formattedDate1}</div><div>{formattedTime}</div></div>;
                    }
                        
                }
            },

            {
                Header: 'User ID',
                accessor: 'o_user_initby'
            },
            // {
            //     Header: 'Order No.',
            //     accessor: 'o_orderno'
            // },
           
            
          
            // {
            //     Header: <div className="text-right">Average Prc.</div>,
            //     accessor: 'averageprice',
            //     Cell: (v: any) => {
            //         if (v.value||v.value ===0)
            //             return (
            //                 <div className="text-right">
            //                     {numberWithCommas(v.value, 4)}
            //                 </div>
            //             );
            //     }
            // },
            // {
            //     Header: <div className="text-right">Match Amount</div>,
            //     accessor: 'matchedprice',
            //     Cell: (v: any) => {
            //         if (v.value||v.value ===0)
            //             return (
            //                 <div className="text-right">
            //                     {numberWithCommas(v.value, 2)}
            //                 </div>
            //             );
            //     }
            // },
           
            {
                Header: 'Last Status',
                accessor: 'o_last_status',

                Cell: (v: any) => {
                    if (v.value)
                        return (
                            <>{Property.lastStatusText[v.value]}</>
                        );
                }
            }, 
            // {
            //     Header: 'Validity',
            //     accessor: 'validity_name'
            // },
            {
                Header: 'Source',
                accessor: 'o_source',
               Cell: (v: any) => {
         
                    const sourceLabel = Property.oSourceText[v.value] ?? v.value;
                    return (
                    <>{sourceLabel}</>
                    );
                    
                }
            }
        ],
        []
    );

    const handleTradeHistorySummary = (summary:any = {}) => {
        let buy = summary.buy || {};
        let sell = summary.sell || {};

        if (buy) {
            let data = total_buy_sell_table_format();
            for (var i = 0; i < data.length; i++) {
                let col = data[i];
                let id = col.id;

                let cValue = buy[id]; //buy value

                col.value = cValue || '-';

                // alert(buy[id]);
                // alert(JSON.stringify(col));
                // if (buy[id]) col.value = buy[id];
            }

            setTotalBuyData([...data]);
        }

        if (sell) {
            let data = total_buy_sell_table_format();
            for (var z = 0; z < data.length; z++) {
                let col = data[z];
                let id = col.id;

                let cValue = sell[id]; //sell value
                col.value = cValue || '-';
            }
            // alert(JSON.stringify(data));
            setTotalSellData(data);
        }
    };

    const handleResetTables = () => {
        //reset data
        setTableData([]);
        setTotalBuyData(null);
        setTotalSellData(null);
        setNotiLoading(false);
    };

    const fetchExpandedData = async (rowData:any) => {

        try {
            let o_orderno = rowData.o_orderno;
       
            return (<>
                <div className='pl-5 pr-5 pt-2 pb-5' 
                style={
                    {

                        maxHeight:"500px",
                        overflow:"auto"
                    }
                }>
                    <div className='sub-title'>Order Logs ({o_orderno})</div>
                    <div className='pt-2'><TradeOrderLogsTbl orderNo={o_orderno}/></div>
                </div>
            </>)
          
        } catch (error) {
          console.error("Error fetching expanded data:", error);
          return <div>Error fetching data</div>;
        }
    };

    const handleSidebarToggle = () => {
        setIsSidebarCollapsed(!isSidebarCollapsed);
    };
    
   
    const convertPropertyToOptions = (obj:any) => {
        // Convert object entries to array format
        const options = Object.entries(obj).map(([key, value]) => ({
          value: key,
          label: value
        }));
      
        // Add the "All" option at the beginning
        options.unshift({ value: '', label: 'All' });
      
        return options;
    };



    
    const filterColumns = [

        {
            type: "selectUser",
            mode:1
        },
        {
            type: "selectExchangeAndStock",
        },
        {   
            id:"side",
            label:"Side",
            type:"select",
            options:convertPropertyToOptions(statusText.tradeSides)
        },
        {   
            id:"category",
            label:"Order Entry",
            type:"select",
            options:convertPropertyToOptions(Property.orderEntry)
        },
        {   
            id:"mode",
            label:"Mode",
            type:"select",
            options:[
                { value: '', label: 'All' },
                { value: '1', label: 'Online' },
                { value: '2', label: 'Offline' }   
            ]
        },
        // {   
        //     id:"type",
        //     label:"Category Type",
        //     type:"select",
        //     options:convertPropertyToOptions(Property.categoryTypeText)
        // },
        {
            type:"selectDateRangePicker"
        }
    ]

    return (
        <MotionLayout>
          <div className={`page-layout  ${isSidebarCollapsed ? 'collapsed' : ''}`}>
                <div className="side-bar" style={{
                    width: isSidebarCollapsed ? '0' : siderWidth
                }}>
                    <CloseButton 
                        handleClick={handleSidebarToggle}
                    />
                    <div className='content' style={{width:siderWidth}}>
                        <div className="main-title ">Trade History</div>
                        <FilterInputBuilder 
                            loading={tableLoading}
                            columns={filterColumns} 
                            initSearchWhenReceived={[`accounts[]`]}  
                            onSearchSubmit={(inputs:any)=>{
                                let currentAccNo = inputs['accounts[]'] || [];
                                // console.log("onSearchSubmit", inputs);
                                setInputs(inputs);
                                preSubmitRequest(currentAccNo, inputs);
                            }}
                        />
                    </div>
                </div>
                <div className="main-content " style={{
                    marginLeft: isSidebarCollapsed ? '0px' : siderWidth,
                    paddingLeft: isSidebarCollapsed ? '0px' : '20px',
                 
                }}>
                    <OpenButton 
                        isSidebarCollapsed={isSidebarCollapsed}
                        handleClick={handleSidebarToggle}
                    />
                    {/* <div className='pt-3'></div> */}
                    <form onSubmit={handleSubmit}>
                        <div className=" text-left ">
        
        
                            <div className="row input-column-gap">
                                {' '}        
                                {/* ....... */}
                                <div className="col-md-12 col-12 pt-1 w-100">
                                    <ReactTable
                                        columns={tblColumns}
                                        data={tableData}
                                        pageSize={10}
                                        currentPage={tablePagination.currentPage}
                                        totalRecords={tablePagination.totalRecords}
                                        pageChange={(cPage: number) => {
                                            // showNotiLoader();
                                            requestGetTradeHistorytAPI(null,null, cPage);
                                        }}
                                        hasPagination
                                        fetchExpandedData={fetchExpandedData}
                                        size={"small"}
                                        loading={tableLoading}
                                    />
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        
        </MotionLayout>
    );
};

export default Index;

